/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, MutableRefObject, useCallback } from 'react';
import { Plus } from 'lucide-react';
import FABActionDialog from './FABActionDialog';
import { ViewPosition } from '../types/types';
import '../styles/FABStyles.css';

interface FABMenuProps {
  pannellumViewerRef: MutableRefObject<any>;
  photoId?: number;
  onHotspotCreated?: () => Promise<void>;
}

const FABMenu: React.FC<FABMenuProps> = ({ pannellumViewerRef, photoId, onHotspotCreated }) => {
  const [actionDialogOpen, setActionDialogOpen] = useState(false);
  const [viewPosition, setViewPosition] = useState<ViewPosition | null>(null);

  const captureViewPosition = useCallback(() => {
    if (pannellumViewerRef.current && photoId) {
      try {
        const pitch = pannellumViewerRef.current.getPitch();
        const yaw = pannellumViewerRef.current.getYaw();
        const hfov = pannellumViewerRef.current.getHfov();
        setViewPosition({ pitch, yaw, hfov });
        return true;
      } catch (error) {
        console.error('Error getting view position:', error);
        return false;
      }
    }
    return false;
  }, [pannellumViewerRef, photoId]);

  const handleCameraClick = useCallback(() => {
    if (captureViewPosition()) {
      setActionDialogOpen(true);
    }
  }, [captureViewPosition]);

  const handleDialogSuccess = useCallback(() => {
    setActionDialogOpen(false);
    setViewPosition(null);
  }, []);

  return (
    <>
      {/* Single plus button - no menu needed for just one action */}
      <div
        className="custom-fab-menu-btn"
        onClick={handleCameraClick}
        data-tooltip="Add Photo"
      >
        <Plus className="w-5 h-5 text-white" />
      </div>

      <FABActionDialog
        open={actionDialogOpen}
        setOpen={setActionDialogOpen}
        photoId={photoId}
        viewPosition={viewPosition}
        onSuccess={handleDialogSuccess}
        onHotspotCreated={onHotspotCreated}
      />
    </>
  );
};

export default FABMenu;
